export const formatCurrency = (num: number | string): string => {
  const number = Number(num)
  if (number !== 0 && !number) return 'R$ 0,00'
  return `R$ ${number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

export const formatCurrencyOrDash = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '—'
  return formatCurrency(value)
}

export const parseCurrency = (str: string): string => {
  const cleaned = str.replace(/[^\d,-]/g, '').replace(',', '.')
  const parsed = parseFloat(cleaned)
  return isNaN(parsed) ? '' : parsed.toFixed(2)
}

/**
 * Formata um telefone brasileiro quando vier sem máscara do banco.
 * Idempotente (aceita valores já formatados) e tolera DDI 55.
 * - 11 dígitos (celular): (XX) XXXXX-XXXX
 * - 10 dígitos (fixo):    (XX) XXXX-XXXX
 * Se não reconhecer o padrão, devolve o valor original.
 */
/** `CRM 52886-BA` — número com UF quando disponível; vazio sem CRM. */
export const formatCrm = (crm: string, crmUf: string): string => {
  if (!crm) return ''
  return `CRM ${crm}${crmUf ? `-${crmUf}` : ''}`
}

export const formatPhone = (phone: string | null | undefined): string => {
  if (!phone) return ''
  const digits = phone.replace(/\D/g, '')
  const local = digits.length > 11 && digits.startsWith('55') ? digits.slice(2) : digits

  if (local.length === 11) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`
  }
  if (local.length === 10) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`
  }
  return phone
}

const proportionalityLabel: Record<string, string> = {
  PROPORTIONAL_WITH_LIMIT: 'Proporcional com limite',
  PROPORTIONAL_WITHOUT_LIMIT: 'Proporcional sem limite',
  INTEGRAL: 'Integral'
}

export const formatProportionalityRule = (ruleKey: string | null | undefined) => {
  if (!ruleKey) {
    return 'N/A'
  }

  return proportionalityLabel[ruleKey] || ruleKey
}

export const dictRepassMode: Record<string, string> = {
  FLOW: 'Fluxo',
  IMMEDIATE: 'À vista'
}

export const formatRepassMode = (modeKey: string | null | undefined): string => {
  if (!modeKey) {
    return 'N/A'
  }
  return dictRepassMode[modeKey] || modeKey
}

export const formatDecimalHoursToHHMM = (
  decimalHours: string | number | null | undefined
): string => {
  if (decimalHours === null || decimalHours === undefined) {
    return '00:00 horas'
  }

  const sanitizedInput = String(decimalHours).replace(',', '.')
  const num = parseFloat(sanitizedInput)

  if (isNaN(num) || num <= 0) {
    return '00:00 horas'
  }

  const hours = Math.floor(num)
  const minutes = Math.round((num - hours) * 60)

  const paddedHours = String(hours).padStart(2, '0')
  const paddedMinutes = String(minutes).padStart(2, '0')

  return `${paddedHours}:${paddedMinutes} horas`
}

export const formatCurrencyValue = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return 'R$ 0,00'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}
